var _circle, _mask, _g, _path, _circle2, _circle3, _path2, _path3, _path4, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRetirement = function SvgRetirement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 73,
    r: 49.5,
    fill: "#E5F5FF",
    stroke: "#18191B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "retirement_svg__a",
    width: 100,
    height: 100,
    x: 15,
    y: 23,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 73,
    r: 49.5,
    fill: "#E5F5FF",
    stroke: "#18191B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#retirement_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#383C42",
    d: "M53.277 49.495c2.28 1.23 5.587 1.244 8.293.972.701-.07 1.36.303 1.744.88.383.575.448 1.273.075 1.839l-3.694 5.605c-.98 1.485-.135 3.441 1.35 4.142 2.472 1.164 5.129 3.147 7.491 5.419 2.362 2.27 4.403 4.804 5.657 7.048 1.893 3.388 3.704 7.423 4.643 11.258.944 3.856.978 7.397-.53 9.892-2.263 3.747-6.128 5.083-8.192 5.349a3.9 3.9 0 0 0-1.158.344c-1.276.604-5.661 2.257-15.442 2.257-9.791 0-14.37-1.656-15.72-2.264a3.9 3.9 0 0 0-1.208-.319c-1.593-.158-4.544-1.03-6.736-3.65-3.027-3.618-4.295-13.14 3.538-23.703 4.735-6.386 9.758-9.922 13.029-11.555 1.458-.728 2.2-2.685 1.219-4.121l-5.318-7.79c-.59-.863-.13-1.966.835-2.132 1.463-.25 3.334-.482 5.18-.465 1.858.017 3.634.287 4.944.994Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31C48D",
    stroke: "#18191B",
    d: "M53.692 58c-2.218 0-4.69.501-6.349.939-.808.214-1.343.958-1.343 1.794 0 1.192 1.063 2.106 2.246 1.97 1.646-.189 3.718-.37 5.446-.37 1.839 0 4.16.205 5.941.406 1.12.127 2.139-.686 2.233-1.808.078-.929-.51-1.785-1.418-1.998-1.86-.437-4.548-.933-6.756-.933Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#18191B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M52 73v16M55 73c0 3.016 1 6.017 1 9.032V89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#18191B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M58.877 77.508c-.205-.886-1.165-1.625-2.042-1.97-.642-.252-1.333-.34-2.016-.45-.418-.068-.833-.128-1.252-.053-.553.099-1.142.069-1.671.262-1.092.4-2.16 1.03-2.765 1.98-.456.713-.446 1.575-.388 2.376.018.252.046.607.266.785.361.29.78.546 1.226.706a7.5 7.5 0 0 0 1.877.429c.732.06 1.458.278 2.167.456.768.193 1.524.392 2.245.707.224.097.425.296.632.425.233.146.44.291.627.485.255.262.697.513.824.85.255.676.409 1.37.392 2.086-.008.336-.266 1.15-.733 1.222-.3.046-.612.218-.895.328-.639.252-1.382.461-2.062.595-.668.13-1.414.21-2.097.25-.464.027-.966.048-1.424-.044-1.096-.221-1.711-1.163-2.417-1.886-.473-.483-.872-1.03-1.371-1.49M52 89v2M56 88v3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 51.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 65.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 51.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 65.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 61.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 67.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 67.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 51.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 63.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 51.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 63.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 61.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 69.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 61.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 69.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 61.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 63.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 65.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 67.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 63.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 71.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 61.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 63.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 51.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 61.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 51.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 61.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 51.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 59.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 55.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 35.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 53.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 35.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 51.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 31.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 31.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 29.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 35.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 35.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 49.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 51.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 57.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 31.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 31.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 35.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 31.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 31.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 29.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 29.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 29.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 27.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 29.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 27.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 27.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 27.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 27.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 29.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 31.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 27.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 26.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 25.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 25.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 25.5,
    r: 0.5,
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FACA15",
    stroke: "#18191B",
    d: "M76.498 110.192c-5.347 0-7.09-1.858-7.292-2.538V78.321c0-.543 1.459-2.13 7.292-2.13s6.888 1.587 6.685 2.13v29.333c0 .68-1.337 2.538-6.685 2.538ZM94.498 107.692c-5.347 0-7.09-2.14-7.292-3.21V58.259c0-.855 1.459-2.568 7.292-2.568s6.888 1.712 6.685 2.568v46.223c0 1.07-1.337 3.21-6.685 3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FACA15",
    stroke: "#18191B",
    d: "M88.206 112.692c-5.348 0-6.797-1.741-7-2.112v-16c0-.296 1.166-1.888 7-1.888s7.18 1.592 6.977 1.888v16c0 .371-1.63 2.112-6.977 2.112Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FACA15",
    stroke: "#18191B",
    d: "M88.206 112.691c-5.348 0-6.797-1.74-7-2.111v-16c0-.296 1.166-1.889 7-1.889s7.18 1.593 6.977 1.89v15.999c0 .371-1.63 2.111-6.977 2.111ZM33 108c-5.348 0-6.797-1.741-7-2.111v-16C26 89.593 27.166 88 33 88s7.18 1.593 6.977 1.889v16c0 .37-1.63 2.111-6.977 2.111Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#18191B",
    d: "M69.206 78.192c-.167 1 1 3 7 3s7.166-2 7-3M81.22 94.691c-.166 1 1 3 7 3s7.168-2 7-3M26.015 90c-.167 1 1 3 7 3s7.166-2 7-3M87.22 57.692c-.166 1 1 3 7 3 6.001 0 7.168-2 7.001-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#18191B",
    strokeLinecap: "round",
    d: "M87.22 72.692c-.166 1 1 3 7 3M87.22 74.692c-.166 1 1 3 7 3M69.22 90.692c-.166 1 1 3 7 3M69.22 96.692c-.166 1 1 3 7 3M69.22 98.692c-.166 1 1 3 7 3M94.22 69.692c6.001 0 7.167-2 7.001-3M94.22 62.692c6.001 0 7.167-2 7.001-3M94.22 71.692c6.001 0 7.167-2 7.001-3M94.22 85.692c6.001 0 7.167-2 7.001-3M88.22 99.691c6 0 7.167-2 7-3M33.015 95c6 0 7.166-2 7-3M88.22 105.691c6 0 7.167-2 7-3M33.015 101c6 0 7.166-2 7-3M76.206 84.692c6 0 7.167-2 7-3M88.22 107.691c6 0 7.167-2 7-3M33.015 103c6 0 7.166-2 7-3M76.206 86.692c6 0 7.167-2 7-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FACA15",
    d: "m86.75 39.524-.648-1.923c-.312-1.776 1.544-2.598 5.956-3.935 2.28-.692 4.789-.625 7.414.53a.43.43 0 0 1 .116.298l.653 1.679c-.488.695-2.255 2.394-5.418 3.625s-6.7.33-8.073-.274"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#18191B",
    d: "m86.102 37.6.647 1.924c1.374.604 4.91 1.504 8.074.274s4.93-2.93 5.418-3.625l-.77-1.977M86.102 37.6c-.31-1.776 1.545-2.598 5.957-3.935 2.28-.692 4.789-.625 7.414.53M86.102 37.6c1.83.805 5.558 1.352 7.871.73 2.474-.663 6.334-3.222 5.499-4.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3A008",
    d: "m69.762 70.582.965-1.786c1.086-1.438 2.953-.642 6.94 1.672 2.061 1.197 3.723 3.077 4.669 5.784a.43.43 0 0 1-.14.288l-.781 1.623c-.842.117-3.29-.016-6.347-1.49s-4.811-4.675-5.306-6.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#18191B",
    d: "m70.727 68.796-.965 1.786c.495 1.416 2.249 4.617 5.306 6.09 3.057 1.475 5.505 1.608 6.347 1.49l.92-1.91m-11.608-7.456c1.086-1.438 2.953-.642 6.94 1.672 2.061 1.197 3.723 3.077 4.669 5.784m-11.61-7.456c.66 1.888 2.803 4.988 4.835 6.256 2.173 1.356 6.676 2.434 6.775 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#18191B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M97.95 28.574c.516-2.267 1.222-4.513 1.637-6.81.489-2.706 1.221-5.35 1.835-8.028.137-.598.225-1.132.225-1.736M91.393 19.692c.037 2.037.119 4.07.119 6.114 0 .914-.239 1.921-.239 2.828M69.278 67.495c-.44-.428-.952-.79-1.431-1.174M70.423 66.121c-.115-.507-.16-1.025-.315-1.523-.065-.21-.157-.409-.2-.624M81.903 71.59c.093-.538.028-1.088.028-1.633M82.648 72.763c.476-.094.931-.262 1.402-.372"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18191B",
    fillRule: "evenodd",
    d: "M24.647 115.5a.5.5 0 0 0-1 0v2.147H21.5a.5.5 0 0 0 0 1h2.147v2.147a.5.5 0 0 0 1 0v-2.147h2.147a.5.5 0 0 0 0-1h-2.147z",
    clipRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 73,
    r: 49.5,
    stroke: "#18191B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 28,
    r: 22.5,
    fill: "#7EC4F6",
    stroke: "#18191B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FACA15",
    d: "m86.544 39.524-.648-1.924c-.311-1.775 1.544-2.598 5.956-3.934 2.28-.692 4.79-.625 7.414.53a.43.43 0 0 1 .116.298l.653 1.678c-.488.696-2.255 2.395-5.418 3.626s-6.7.33-8.073-.274"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#18191B",
    d: "m85.896 37.6.648 1.924c1.373.604 4.91 1.504 8.073.274s4.93-2.93 5.418-3.626l-.769-1.976M85.896 37.6c-.311-1.775 1.544-2.598 5.956-3.934 2.28-.692 4.79-.625 7.414.53M85.896 37.6c1.83.806 5.558 1.353 7.872.732 2.473-.664 6.333-3.223 5.498-4.136"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#18191B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M97.745 28.574c.515-2.267 1.221-4.513 1.636-6.81.489-2.706 1.221-5.35 1.835-8.028.137-.598.225-1.132.225-1.736M91.187 19.691c.037 2.038.119 4.071.119 6.115 0 .914-.239 1.921-.239 2.828"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 47.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 45.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 43.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 39.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 35.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 35.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 37.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 35.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 31.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 31.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 33.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 41.5,
    r: 0.5,
    fill: "#18191B"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 46,
    r: 3.5,
    stroke: "#18191B"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 30,
    r: 1.5,
    stroke: "#18191B"
  })));
};
export default SvgRetirement;